module.exports = __webpack_public_path__ + "img/trip-icon_analitico.787a0c8c.svg";